import * as React from 'react';
import { useGroundingCommandBar_unstable } from './useGroundingCommandBar';
import { renderGroundingCommandBar_unstable } from './renderGroundingCommandBar';
import { useGroundingCommandBarStyles_unstable } from './useGroundingCommandBarStyles.styles';
import type { GroundingCommandBarProps } from './GroundingCommandBar.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingCommandBar component - TODO: add more docs
export const GroundingCommandBar: ForwardRefComponent<GroundingCommandBarProps> = React.forwardRef((props, ref) => {
  const state = useGroundingCommandBar_unstable(props, ref);

  useGroundingCommandBarStyles_unstable(state);
  return renderGroundingCommandBar_unstable(state);
});

GroundingCommandBar.displayName = 'GroundingCommandBar';
